export default {
  GET_MODAL_LOADING(state: any) {
    return state.loading.modal;
  },
  GET_MODAL_LOADING_PAYMENT(state: any) {
    return state.loading.modalPayment;
  },
};
